export interface CommentItem {
  id: string;
  articleId: string;
  author: string;
  content: string;
  date: string;
  likes: number;
}

export const mockComments: CommentItem[] = [
  {
    id: 'c1',
    articleId: '1',
    author: '吃瓜一线',
    content: '我的天呐！终于有人爆这个了，我朋友就在那个酒店上班，亲眼看到的，绝对不是空穴来风！这个瓜保熟！',
    date: '2026-06-28 15:32',
    likes: 1280,
  },
  {
    id: 'c2',
    articleId: '1',
    author: '匿名用户',
    content: '作为一个十年老粉，真的心碎了。但还是等工作室正式回应吧，现在说太早。',
    date: '2026-06-28 15:18',
    likes: 856,
  },
  {
    id: 'c3',
    articleId: '1',
    author: '娱乐观察家',
    content: '业内人士表示，这个时间点被爆出来很微妙，正好是新剧开播前两周，懂的都懂。',
    date: '2026-06-28 14:55',
    likes: 2340,
  },
  {
    id: 'c4',
    articleId: '1',
    author: '理性吃瓜人',
    content: '说实话这照片也太糊了，连脸都看不清就说是什么顶流，营销号能不能靠谱点？一张糊图就敢写几千字小作文。',
    date: '2026-06-28 14:30',
    likes: 621,
  },
  {
    id: 'c5',
    articleId: '1',
    author: '资深瓜农',
    content: '我整理了时间线：上个月开始两人就在同一个城市出现，同款帽子、同款卫衣至少有三次，不是巧合。坐等官宣。',
    date: '2026-06-28 14:12',
    likes: 3100,
  },
  {
    id: 'c6',
    articleId: '1',
    author: '纯路人',
    content: '现在的热搜真是越来越无聊了，人家谈恋爱关我们什么事，不如关注一下最近的社会新闻。不过……这瓜我先吃为敬！',
    date: '2026-06-28 13:48',
    likes: 445,
  },
  {
    id: 'c7',
    articleId: '4',
    author: '八卦雷达',
    content: '我就说最近怎么觉得这两人不对劲，之前综艺上的互动明显少了，眼神也不对。果然出问题了。',
    date: '2026-06-27 22:10',
    likes: 1890,
  },
  {
    id: 'c8',
    articleId: '4',
    author: '老粉不请自来',
    content: '追了这对CP五年了，从他们第一次公开亮相就在关注。如果真离了，我再也不相信娱乐圈的爱情了。',
    date: '2026-06-27 21:35',
    likes: 1560,
  },
  {
    id: 'c9',
    articleId: '4',
    author: '理性分析',
    content: '取关不一定就是婚变吧……说不定是两个人约好了清空社交媒体重新开始呢？不要急着下结论。',
    date: '2026-06-27 20:50',
    likes: 723,
  },
  {
    id: 'c10',
    articleId: '6',
    author: '现场工作人员',
    content: '当时我就在录制现场，场面比描述的还要激烈。嘉宾A直接摔了麦克风，整个棚都安静了，导演脸都绿了。',
    date: '2026-06-26 18:20',
    likes: 4120,
  },
  {
    id: 'c11',
    articleId: '6',
    author: '综艺老观众',
    content: '这节目本来就走争议路线，说不定是剧本呢？现在的综艺为了收视率什么都干得出来。',
    date: '2026-06-26 17:55',
    likes: 980,
  },
  {
    id: 'c12',
    articleId: '10',
    author: '数据党',
    content: '这个榜单还算客观，我统计了各平台热搜时长，第一名确实实至名归。不过第二名排低了，那个维权事件影响太大了。',
    date: '2026-06-25 16:40',
    likes: 1350,
  },
  {
    id: 'c13',
    articleId: '10',
    author: '每日大赛钉子户',
    content: '上半年大赛我可以给8.5分！每一个瓜都值得反复回味，下半年的选手们压力很大啊哈哈。',
    date: '2026-06-25 15:30',
    likes: 2100,
  },
  {
    id: 'c14',
    articleId: '2',
    author: '被坑消费者',
    content: '我就是三万人之一！买了那个所谓的“神效精华”，用了一周满脸过敏，退货还不给退。终于有人曝光了！',
    date: '2026-06-28 09:15',
    likes: 5600,
  },
  {
    id: 'c15',
    articleId: '2',
    author: '打假斗士',
    content: '我之前就发过视频质疑过，结果被粉丝举报到限流。现在终于真相大白了，正义虽然迟到但不会缺席。',
    date: '2026-06-28 08:42',
    likes: 3200,
  },
];